<template>
	<div class="header-content page">
		<div class="home-page-header flex padding shandow border">
			<div class="title" @click="toHome">居时智能空间系统</div>
			<div class="handle flex">
				<a href="javascript:void(0);" @click="$router.push({path:'/'})">项目管理</a>
				<a href="javascript:void(0);" v-if="roleId==1" @click="$router.push({path:'/user'})">用户管理</a>
			</div>
			<div class="admin-info">
				<a href="javascript:void(0);">{{ username }}</a>
				<a href="javascript:void(0);" @click="logout">退出</a>
			</div>
		</div>
		<!-- <Breadcrumb></Breadcrumb> -->
	</div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import {removeToken} from "@/util/auth";

export default {
	name: "home-page",
	components: {
		Breadcrumb
	},
	data() {
		return {
			username: localStorage.getItem("username"),
			roleId: localStorage.getItem("roleId"),
			steps: []
		};
	},
	methods: {
		logout() {
			removeToken();
			location.reload();
		},
		toHome() {
			this.$router.push({name: 'home'})
		}
	}
};
</script>

<style lang="scss" scoped>
.header-content {
	.home-page-header {
		box-sizing: border-box;
		justify-content: space-between;
		height: 60px;
		background: #fff;
		font-size: 16px;
		color: #333;

		.handle {
			height: 100%;
		}

		.handle a {
			display: block;
			width: 120px;
			line-height: 60px;
			color: #333;
			text-align: center;
		}

		.active {
			background: #ddd;
		}

		.title {
			cursor: pointer;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/header.vue